
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plus/agenda",
      function () {
        return require("private-next-pages/plus/agenda/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plus/agenda"])
      });
    }
  